import { LJ_ARTICLE_ROUTE, ljVideoRoute } from "@/lib/routes";

export type LjArticle = {
  category: string;
  title: string;
  image: string;
  href: string;
  author?: string;
};

export type LjVideo = LjArticle & {
  duration: string;
  /** YouTube id, so the article page can embed the film above the text. */
  youtubeId: string;
};

export const HERO_ARTICLE: LjArticle = {
  category: "Travel & Sports",
  title: "追浪逐夢 港隊新星Marcus Lau",
  // The article's own lead photograph, so the card and the page it opens are
  // the same picture rather than two different shots of the same subject.
  image: "/images/lj/article-detail/hero-marcus-surf.png",
  // Locale-less: consumers render it through next-intl's `Link`, which
  // prefixes the active locale. The hardcoded `/zh-TW` pinned every reader
  // into the Traditional tree.
  href: LJ_ARTICLE_ROUTE,
  author: "陳子健",
};

export const LATEST_ARTICLES: LjArticle[] = [
  {
    category: "Fashion",
    title: "3月開倉：巴黎生活藝術品牌Maison Kitsuné",
    image: "/images/lj/articles/latest-fashion-kitsune.png",
    href: LJ_ARTICLE_ROUTE,
    author: "梁芷晴",
  },
  {
    category: "Design & Machines",
    title: "超越觸覺的 居家按摩體驗",
    image: "/images/lj/articles/latest-design-massage.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Health & Beauty",
    title: "天然、安全的染髮選擇",
    image: "/images/lj/articles/latest-health-hair.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Art & Culture",
    title: "珍藏香港~藝術博覽",
    image: "/images/lj/articles/latest-art-fair.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Food & Wine",
    title: "茶與琴酒的當代對話｜Monkey 47 x Tell Camellia",
    image: "/images/lj/articles/latest-foodwine-monkey47.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Travel & Sports",
    title: "速度新解Endorphin Azura",
    image: "/images/lj/articles/latest-travel-endorphin.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "高訂新時代：SS26 HAUTE COUTURE HIGHLIGHTS",
    image: "/images/lj/articles/latest-features-couture.png",
    href: LJ_ARTICLE_ROUTE,
    author: "李曉欣",
  },
  {
    category: "Features",
    title: "非凡創意與工藝 Cartier Prive系列第十篇章及Tortue系列新作",
    image: "/images/lj/articles/latest-cartier-prive.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Design & Machines",
    title: "Devialet Phantom Ultimate Roland Garros限量版",
    image: "/images/lj/articles/latest-devialet-phantom.jpg",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Art & Culture",
    title: "為何《Matilda瑪蒂爾達》成為全球音樂劇經典？",
    image: "/images/lj/articles/latest-matilda-musical.jpg",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Food & Wine",
    title: "Taste Master Series精彩新章",
    image: "/images/lj/articles/latest-taste-master.jpg",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Food & Wine",
    title: "CulinArt 1862 五月法式藝術饗宴",
    image: "/images/lj/articles/latest-culinart-1862.jpg",
    href: LJ_ARTICLE_ROUTE,
  },
];

export const POPULAR_ARTICLES: LjArticle[] = [
  {
    category: "Travel & Sports",
    title: "追浪逐夢 港隊新星Marcus Lau",
    image: "/images/lj/articles/popular-marcus.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Art & Culture",
    title: "炭火不滅的一杯茶",
    image: "/images/lj/articles/popular-tea.png",
    href: LJ_ARTICLE_ROUTE,
    author: "張詠茗",
  },
  {
    category: "Art & Culture",
    title: "當鉛字再次落版時",
    image: "/images/lj/articles/popular-typeset.png",
    href: LJ_ARTICLE_ROUTE,
    author: "黃浩然",
  },
  // A fourth — every rail that renders this list asks for four
  // (`slice(0, 4)`), so with three the ranked strip came up short and sat
  // shorter than the ad beside it. QA: "Most Popular: add one more article
  // item (total 4)".
  {
    category: "Fashion",
    title: "高訂新時代：SS26 HAUTE COUTURE HIGHLIGHTS",
    image: "/images/lj/articles/latest-features-couture.png",
    href: LJ_ARTICLE_ROUTE,
    author: "梁芷晴",
  },
];

export const RECOMMENDED_ARTICLES: LjArticle[] = [
  {
    category: "Silhouette",
    title: "財富管理服務新高峰",
    image: "/images/lj/articles/rec-silhouette-wealth.png",
    href: LJ_ARTICLE_ROUTE,
    author: "許嘉敏",
  },
  {
    category: "Watch & Jewelry",
    title: "延續先鋒精神｜Freak X Gumball 3000 2.0",
    image: "/images/lj/articles/rec-watch-freak.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Design & Machines",
    title: "無縫AI相機體驗",
    image: "/images/lj/articles/rec-design-aicamera.png",
    href: LJ_ARTICLE_ROUTE,
    author: "馮兆希",
  },
  {
    category: "Fashion",
    title: "充滿藝術氛圍的購物空間",
    image: "/images/lj/articles/rec-fashion-shopping.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Travel & Sports",
    title: "追浪逐夢 港隊新星Marcus Lau",
    image: "/images/lj/articles/rec-travel-marcus.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Watch & Jewelry",
    title: "CHOPARD Zagato Lab One Conceptt 概念腕錶",
    image: "/images/lj/articles/rec-watch-chopard.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Fashion",
    title: "Double Vision香港時尚新力量的雙重視野",
    image: "/images/lj/articles/rec-fashion-double.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Design & Machines",
    title: "Minotti室內裝飾部主管Susanna Minotti︰把生活寫進空間",
    image: "/images/lj/articles/rec-design-minotti.png",
    href: LJ_ARTICLE_ROUTE,
  },
];

export const LATEST_VIDEOS: LjVideo[] = [
  {
    category: "Watch & Jewelry",
    title: "Emporio Armani 的假日意義",
    image: "/images/lj/articles/video-armani.png",
    href: ljVideoRoute("dQw4w9WgXcQ"),
    duration: "08:24",
    youtubeId: "dQw4w9WgXcQ",
  },
  {
    category: "Fashion",
    title: "打扮 ‧ 從心",
    image: "/images/lj/articles/video-fashion.png",
    href: ljVideoRoute("M7lc1UVf-VE"),
    duration: "08:24",
    youtubeId: "M7lc1UVf-VE",
  },
  {
    category: "Fashion",
    title: "回到 80’s Pop",
    image: "/images/lj/articles/video-80s.png",
    href: ljVideoRoute("aqz-KE-bpKQ"),
    duration: "08:24",
    youtubeId: "aqz-KE-bpKQ",
  },
  {
    category: "Fashion",
    title: "Dior 2022 Cruise系列：紗裙女神",
    image: "/images/lj/articles/video-dior-cruise.jpg",
    href: ljVideoRoute("ScMzIvxBSi4"),
    duration: "06:42",
    youtubeId: "ScMzIvxBSi4",
  },
  {
    category: "Fashion",
    title: "Dior永續Bar Jacket",
    image: "/images/lj/articles/video-dior-bar.jpg",
    href: ljVideoRoute("5qap5aO4i9A"),
    duration: "09:18",
    youtubeId: "5qap5aO4i9A",
  },
  {
    category: "Fashion",
    title: "Emporio Armani的時裝對話",
    image: "/images/lj/articles/video-armani-dialogue.jpg",
    href: ljVideoRoute("jNQXAC9IVRw"),
    duration: "07:55",
    youtubeId: "jNQXAC9IVRw",
  },
  {
    category: "Fashion",
    title: "自己手袋瑞士人畫",
    image: "/images/lj/articles/video-lv-bags.jpg",
    href: ljVideoRoute("9bZkp7q19f0"),
    duration: "05:30",
    youtubeId: "9bZkp7q19f0",
  },
  {
    category: "Health & Beauty",
    title: "【Loro Piana】跟林德信在Cashmere墊上做瑜伽",
    image: "/images/lj/articles/video-loropiana-yoga.jpg",
    href: ljVideoRoute("kJQP7kW5nhg"),
    duration: "11:12",
    youtubeId: "kJQP7kW5nhg",
  },
  /*
    Three more, so `/lj/video`'s MORE STORIES has a section rather than a
    remainder — QA: "add three more video items to the more stories section".
    The eight above shipped with the build; these three are composed from the
    magazine's own subjects and its existing stills, since the live site's
    video listing renders client-side and exposes only its lead item to a
    fetch. Swap them for real films when the feed lands.
  */
  {
    category: "Watch & Jewelry",
    title: "卡地亞Privé系列 錶殼線條的一堂課",
    image: "/images/lj/articles/latest-cartier-prive.png",
    href: ljVideoRoute("hT_nvWreIhg"),
    duration: "06:18",
    youtubeId: "hT_nvWreIhg",
  },
  {
    category: "Design & Machines",
    title: "無縫AI相機體驗 攝影師的一日實測",
    image: "/images/lj/articles/rec-design-aicamera.png",
    href: ljVideoRoute("YQHsXMglC9A"),
    duration: "08:47",
    youtubeId: "YQHsXMglC9A",
  },
  {
    category: "Fashion",
    title: "Double Vision 香港時尚新力量的雙重視野",
    image: "/images/lj/articles/rec-fashion-double.png",
    href: ljVideoRoute("CevxZvSJLk8"),
    duration: "10:05",
    youtubeId: "CevxZvSJLk8",
  },
];

/**
 * 專題 — the magazine's long-form features.
 *
 * `/lj/features` is a section of the live magazine that this build never had a
 * route for. Titles are the real ones, read off lj.hkej.com/lj/features; the
 * photography is not ours to copy, so each row takes a still from the LJ pool
 * that matches its subject. Several are the cover stories the e-paper's issue
 * picker already lists, which is exactly how the two relate on the live site.
 */
export const LJ_FEATURES: LjArticle[] = [
  {
    category: "Features",
    title: "設計走到最後，是為生活留下更多可能",
    image: "/images/lj/articles/rec-design-minotti.png",
    href: LJ_ARTICLE_ROUTE,
    author: "梁志天",
  },
  {
    category: "Features",
    title: "FRED, The Sunshine Jeweler陽光珠寶商",
    image: "/images/lj/articles/rec-watch-chopard.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "由紙紮佬到藝術家",
    image: "/images/lj/articles/latest-art-fair.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "寶石的頌歌 卡地亞Le Chœur des Pierres高級珠寶系列",
    image: "/images/lj/articles/latest-cartier-prive.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title:
      "CHANEL Signes & Symboles 頂級珠寶系列 讀懂Gabrielle Chanel藝術宇宙的核心意象",
    image: "/images/lj/articles/latest-watch-chanel.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "探索大自然瑰麗奧秘 Tiffany & Co. Blue Book 2026: Hidden Garden高級珠寶系列",
    image: "/images/lj/articles/latest-features-couture.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "Longchamp X Patrick Jouin 跨界合作 燃亮工藝創意",
    image: "/images/lj/articles/rec-fashion-shopping.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "非凡創意與工藝 Cartier Prive系列第十篇章及Tortue系列新作",
    image: "/images/lj/articles/rec-watch-freak.png",
    href: LJ_ARTICLE_ROUTE,
  },
  {
    category: "Features",
    title: "蠔式傳奇：百年輝煌成就",
    image: "/images/lj/articles/rec-fashion-double.png",
    href: LJ_ARTICLE_ROUTE,
  },
];

export const LJ_CATEGORIES = [
  { label: "WATCH & JEWELRY", href: "/lj/category/watch-jewelry" },
  { label: "FASHION", href: "/lj/category/fashion" },
  { label: "ART & CULTURE", href: "/lj/category/art-culture" },
  { label: "FOOD & WINE", href: "/lj/category/food-wine" },
  { label: "DESIGN & MACHINES", href: "/lj/category/design-machines" },
  { label: "TRAVEL & SPORTS", href: "/lj/category/travel-sports" },
  { label: "HEALTH & BEAUTY", href: "/lj/category/health-beauty" },
  { label: "SILHOUETTE", href: "/lj/category/silhouette" },
] as const;

export const LJ_NAV_SIDE_LINKS = [
  { label: "BLOG", href: "/lj/blog" },
  // Both pointed at `/lj/blog`: the masthead advertised two sections and
  // dropped the reader into a third. QA: "missing Features and Video pages".
  { label: "VIDEO", href: "/lj/video" },
  { label: "FEATURES", href: "/lj/features" },
  { label: "CURRENT ISSUE", href: "/lj/epaper" },
] as const;

export const LJ_FOOTER_ABOUT_LINKS = [
  { label: "關於信報", href: "/about" },
  { label: "服務條款", href: "/legal/membership" },
  { label: "廣告查詢", href: "/contact" },
  { label: "私隱條款", href: "/legal/privacy" },
  { label: "加入信報", href: "/careers" },
  { label: "免責聲明", href: "/legal/disclaimer" },
  { label: "聯絡信報", href: "/contact" },
];
